export default __webpack_public_path__ + "static/media/employment.6461cdb8.png";